import { useFormTemplatesList } from '@monorepo/shared/hooks/formTemplates/useFormTemplatesList';
import { useSearchParamState } from '@monorepo/shared/hooks/navigation/useSearchParamState';
import React from 'react';
import { useParams } from 'react-router-dom';
import { Page } from './styled';
import { ViewFormsHeader } from './ViewFormsHeader';
import { ViewFormsTable } from './ViewFormsTable';

export function ViewFormsPage() {
  const { organizationId } = useParams();
  if (!organizationId) {
    throw new Error(
      "ViewForms page was rendered with url that doesn't have organizationId",
    );
  }

  const { formTemplateList } = useFormTemplatesList({
    organizationId,
  });

  const [filter, setFilter] = useSearchParamState<string>('filter');
  const nonNullFilter = filter ?? '';

  return (
    <Page>
      <ViewFormsHeader
        organizationId={organizationId}
        filter={nonNullFilter}
        onSearch={formTemplateList?.length ? setFilter : undefined}
      />
      <ViewFormsTable filter={nonNullFilter} organizationId={organizationId} />
    </Page>
  );
}
